import React from 'react'
import { Box, Typography, Grid } from "@mui/material";
import DownloadButton from '../../shared/components/DownloadButton';
import SpecialDownloadButton from '../../shared/components/SpecialDouwnloadButton';


export default function AnalyzeResultsDownload() {
    return (
        <Box sx={{ width: '1382px' }}>
            <Box sx={{
                width: '706px',
                height: '85px',
                mb: "70px"
            }}>
                <Typography sx={{ fontSize: '60px' }}>
                    Download
                </Typography>
            </Box>
            <Box sx={{ height: '26px', mb: '180px' }}>
                <Typography variant='text'>
                    Below, you can download each file individually or all files together.
                </Typography>
            </Box>

            <Box>
                <Grid container>
                    <Grid size={{ lg: 4 }}>
                        <DownloadButton type={'fastqc'} mb={'50px'} />
                        <DownloadButton type={'multiqc'} mb={'50px'} />
                        <DownloadButton type={'spades'} mb={'50px'} />
                    </Grid>

                    <Grid size={{ lg: 4 }}>
                        <DownloadButton type={'quast'} mb={'50px'} />
                        <DownloadButton type={'resfinder'} mb={'50px'} />
                        <DownloadButton type={'rgi'} mb={'50px'} />
                    </Grid>

                    <Grid size={{ lg: 4 }}>
                        <DownloadButton type={'virulencefinder'} mb={'50px'} />
                        <DownloadButton type={'sccmec'} mb={'50px'} />
                        <SpecialDownloadButton type={'All files'} mb={'50px'} />
                    </Grid>
                </Grid>
            </Box>

        </Box >
    )
}

